import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dgsnnr77p: FaireProductEntity = {
  token: "p_6dgsnnr77p",
  type: "product",
  name: "Desert Child T-Shirt, Cactus, Retro, Graphic Tee",
  brandToken: "b_uyrp83b3tq",
  brandName: "Soleinspire",
  imageUrl:
    "https://cdn.faire.com/fastly/36867704bc3ca291c1cf37f55c2e2d4b9a45c568f4f6f8095746beb43227c747.webp",
  galleryImageUrls: [],
  priceDollars: 15.94,
  description:
    "This Desert Child T-shirt is a perfect blend of comfort and style. Featuring a unique cactus design set against a desert backdrop with retro vibes, it's ideal for casual wear or a day out in nature. Made from soft, durable fabric, this tee promises both fashion and function. Natural, earth-toned colors make it a versatile addition to your wardrobe. Perfect for those who love the great outdoors, boho style, and distinctive, eye-catching graphics. Keywords: desert t-shirt, cactus shirt, retro graphic tee, boho style, outdoor wear, casual style, unisex t-shirt, nature inspired, earthy tones, adventure tee, soft fabric top, western style shirt, comfortable tee, graphic design, versatile t-shirt, fashion-forward, nature lover gift, classic fit, unique style, distinctive tee.",
  tags: [],
  msrpDollars: 36.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:24.504Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
